var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97659 1.54174C2.70354 1.87176 2.56596 2.29322 2.59167 2.72086V21.2804C2.56598 21.7076 2.70333 22.1286 2.97598 22.4583L3.03759 22.5193L13.3383 12.1227V11.8773L3.03759 1.48071L2.97659 1.54174Z",
    fill: "url(#paint0_linear_772_114871)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7698 15.5894L13.3367 12.1228V11.8775L16.771 8.41089L16.8485 8.45605L20.9161 10.7887C22.0782 11.4551 22.0782 12.5451 20.9161 13.2116L16.8485 15.5448L16.7698 15.5894Z",
    fill: "url(#paint1_linear_772_114871)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8469 15.5454L13.3363 11.9995L2.97339 22.4596C3.20954 22.6699 3.51216 22.7903 3.82815 22.7997C4.14415 22.809 4.45336 22.7068 4.70156 22.5109L16.8469 15.5454Z",
    fill: "url(#paint2_linear_772_114871)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8469 8.45601L4.70156 1.48993C4.45346 1.29379 4.14421 1.19141 3.82814 1.20079C3.51208 1.21016 3.20943 1.33069 2.97339 1.5412L13.3363 11.9995L16.8475 8.45479L16.8469 8.45601Z",
    fill: "url(#paint3_linear_772_114871)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.7694 15.4668L4.70095 22.3877C4.46246 22.571 4.17054 22.6711 3.86982 22.6728C3.56909 22.6744 3.2761 22.5775 3.03561 22.3969L2.97339 22.4591L3.035 22.5202V22.5195C3.27552 22.7007 3.56878 22.7979 3.86982 22.7962C4.17086 22.7946 4.46304 22.6942 4.70156 22.5104L16.8469 15.5449L16.7694 15.4668Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M2.97662 22.3363C2.70362 22.0063 2.56605 21.5849 2.5917 21.1572V21.2799C2.56588 21.7074 2.70323 22.1289 2.97601 22.459L3.03823 22.3968L2.97662 22.3363ZM20.9147 13.0895L16.769 15.4667L16.8465 15.5448L20.9147 13.2122C21.1538 13.1072 21.3606 12.9394 21.5143 12.7264C21.6668 12.5134 21.7614 12.2626 21.7858 12.0007C21.7345 12.2377 21.6291 12.4596 21.4777 12.6489C21.3269 12.8377 21.1341 12.9886 20.9147 13.0895Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.70305 1.61332L20.9172 10.9114C21.1362 11.0115 21.329 11.1622 21.4802 11.3514C21.6315 11.5406 21.7371 11.7628 21.7883 12.0002C21.7639 11.7378 21.67 11.4875 21.5168 11.2739C21.3639 11.0613 21.1565 10.8937 20.9166 10.7887L4.70244 1.49004C3.54098 0.823582 2.59058 1.37713 2.59058 2.72043V2.84249C2.59058 1.49981 3.54098 0.946254 4.70305 1.61271V1.61332Z",
    fill: "#1D2939"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_772_114871",
    x1: 12.4251,
    y1: 2.52495,
    x2: -1.65776,
    y2: 16.4777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_772_114871",
    x1: 22.4289,
    y1: 12.0007,
    x2: 2.31129,
    y2: 12.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_772_114871",
    x1: 14.9388,
    y1: 13.9263,
    x2: -4.15834,
    y2: 32.8476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_772_114871",
    x1: 0.364362,
    y1: -4.63637,
    x2: 8.89219,
    y2: 3.81289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.2352e9a288551fbffeb20c3d335bee7f.svg";
export { ForwardRef as ReactComponent };